'use strict';

exports.__esModule = true;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _style = require('../../src/styles/style.scss');

var _style2 = _interopRequireDefault(_style);

var _pageActions = require('../actions/page-actions');

var _dropdown = require('dropdown');

var _reactIframe = require('react-iframe');

var _reactIframe2 = _interopRequireDefault(_reactIframe);

var _reactRedux = require('react-redux');

var _redux = require('redux');

var _reactIntl = require('react-intl');

var _constants = require('../utils/constants');

var _wfHorizontalWidget = require('./wf-horizontal-widget');

var _wfHorizontalWidget2 = _interopRequireDefault(_wfHorizontalWidget);

var _wfPeerRecommendationWidget = require('./wf-peer-recommendation-widget');

var _wfPeerRecommendationWidget2 = _interopRequireDefault(_wfPeerRecommendationWidget);

var _wfMicroStarWidget = require('./wf-micro-star-widget');

var _wfMicroStarWidget2 = _interopRequireDefault(_wfMicroStarWidget);

var _wfListWidget = require('./wf-list-widget');

var _wfListWidget2 = _interopRequireDefault(_wfListWidget);

var _wfCarouselWidget = require('./wf-carousel-widget');

var _wfCarouselWidget2 = _interopRequireDefault(_wfCarouselWidget);

var _wfGridWidget = require('./wf-grid-widget');

var _wfGridWidget2 = _interopRequireDefault(_wfGridWidget);

var _utils = require('../utils/utils');

var _wfGroupReviewsWidget = require('./wf-group-reviews-widget');

var _wfGroupReviewsWidget2 = _interopRequireDefault(_wfGroupReviewsWidget);

var _reviewBadgeExample = require('./review-badge-example');

var _reviewBadgeExample2 = _interopRequireDefault(_reviewBadgeExample);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _ref = typeof navigator !== 'undefined' && navigator.languages || ['en'],
    locale = _ref[0];

var _locale$split = locale.split('-'),
    localeBase = _locale$split[0];

var lang = require('react-intl/locale-data/' + localeBase);
var messages = void 0;
try {
  messages = require('../../src/lang/' + localeBase + '.json');
} catch (error) {
  messages = require('../../src/lang/en.json');
}
(0, _reactIntl.addLocaleData)(lang);

var _ref2 = _react2.default.createElement(
  'h1',
  null,
  'Widgets Examples'
);

var _ref3 = _react2.default.createElement(
  'h2',
  null,
  'Practice Reviews'
);

var _ref4 = _react2.default.createElement(
  'label',
  null,
  'Disable Banner'
);

var _ref5 = _react2.default.createElement(
  'label',
  null,
  'Disable Profile Image'
);

var _ref6 = _react2.default.createElement(
  'label',
  null,
  'Disable Tabs'
);

var _ref7 = _react2.default.createElement(
  'p',
  null,
  'Code:'
);

var _ref8 = _react2.default.createElement(
  'p',
  null,
  'Preview:'
);

var _ref9 = _react2.default.createElement(
  'p',
  null,
  'No preview to display (no profile selected)'
);

var _ref10 = _react2.default.createElement(
  'h2',
  null,
  'Booking Calendar'
);

var _ref11 = _react2.default.createElement(
  'p',
  null,
  'Code:'
);

var _ref12 = _react2.default.createElement(
  'p',
  null,
  'Preview:'
);

var _ref13 = _react2.default.createElement(
  'p',
  null,
  'No preview to display (no profile selected)'
);

var _ref14 = _react2.default.createElement(
  'h2',
  null,
  'Book button'
);

var _ref15 = _react2.default.createElement(
  'p',
  null,
  'Code:'
);

var _ref16 = _react2.default.createElement(
  'p',
  null,
  'Preview:'
);

var _ref17 = _react2.default.createElement(
  'p',
  null,
  'No preview to display (no profile selected)'
);

var WidgetExamples = function (_React$Component) {
  (0, _inherits3.default)(WidgetExamples, _React$Component);

  function WidgetExamples(props) {
    (0, _classCallCheck3.default)(this, WidgetExamples);
    return (0, _possibleConstructorReturn3.default)(this, _React$Component.call(this, props));
  }

  WidgetExamples.prototype.componentDidMount = function componentDidMount() {
    document.body.style.background = '#eee';
  };

  WidgetExamples.prototype.setCustomizationProp = function setCustomizationProp(prop, value) {
    var customizations = this.props.page.customizations;
    customizations[prop] = value;
    this.props.pageActions.setCustomizationProps(customizations);
  };

  WidgetExamples.prototype.render = function render() {
    var _this2 = this;

    var props = this.props;
    var showDefaultTabDropDown = props.page && props.page.selectedProfileType && (props.page.selectedProfileType.id === _constants.SPECIALIST_PROFILE_TYPE || props.page.selectedProfileType.id === _constants.PRACTICE_PROFILE_TYPE) && props.page.selectedProfile && props.page.selectedProfile.id;

    var baseUrl = location.origin.indexOf('localhost') > -1 && typeof window !== 'undefined' ? 'http://localhost:9090' : location.origin;

    var profileReviewsSearchQuery = '/profile-reviews' + (0, _constants.queryStringFromObject)({
      profileId: props.page.selectedProfile && props.page.selectedProfile.uriId || '',
      profileType: props.page.selectedProfileType && props.page.selectedProfileType.id || '',
      layoutType: props.page.selectedLayout && props.page.selectedLayout.id || '',
      selectedTab: props.page.selectedDefaultTab && props.page.selectedDefaultTab.id || undefined,
      disableBanner: props.page.disableBanner && 'true' || 'false',
      disableProfileImage: props.page.disableProfileImage && 'true' || 'false',
      disableTabs: props.page.disableTabs && 'true' || 'false',
      customizations: (0, _extends3.default)({}, props.page.customizations)
    });

    return _react2.default.createElement(
      _reactIntl.IntlProvider,
      { locale: localeBase, messages: messages },
      _react2.default.createElement(
        'div',
        { className: 'container' },
        _react2.default.createElement(
          'div',
          { className: _style2.default.widgetExamples },
          _ref2,
          _react2.default.createElement(
            'div',
            { className: _style2.default.exampleSection },
            _ref3,
            _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(
                'span',
                { className: _style2.default.selectDescription },
                'Profile Type:'
              ),
              _react2.default.createElement(
                'div',
                { className: _style2.default.dropdownContainer },
                _react2.default.createElement(_dropdown.Dropdown, {
                  className: _style2.default.profileDropdown,
                  items: _constants.PROFILE_TYPES,
                  readonly: true,
                  selectedItem: props.page.selectedProfileType,
                  onItemSelected: props.pageActions.onProfileTypeSelected,
                  placeholder: 'Select a profile type',
                  ItemRenderer: function ItemRenderer(rendererProps) {
                    var item = rendererProps.item,
                        nameTransform = rendererProps.nameTransform;

                    return _react2.default.createElement(
                      'div',
                      { className: '' + _style2.default.dropdownItem },
                      item.iconUri ? _react2.default.createElement('img', { src: item.iconUri }) : _react2.default.createElement('span', { className: _style2.default.imagePlaceholder }),
                      _react2.default.createElement(
                        'span',
                        null,
                        nameTransform(item)
                      )
                    );
                  } })
              ),
              props.page.selectedProfileType && (props.page.selectedProfileType.id === _constants.SPECIALIST_PROFILE_TYPE || props.page.selectedProfileType.id === _constants.PRACTICE_PROFILE_TYPE) && _react2.default.createElement(
                'span',
                { className: _style2.default.selectDescription },
                'Profile:'
              ),
              props.page.selectedProfileType && (props.page.selectedProfileType.id === _constants.SPECIALIST_PROFILE_TYPE || props.page.selectedProfileType.id === _constants.PRACTICE_PROFILE_TYPE) && _react2.default.createElement(
                'div',
                { className: _style2.default.dropdownContainer },
                _react2.default.createElement(_dropdown.Dropdown, {
                  className: _style2.default.profileDropdown,
                  items: props.page.selectedProfileType && props.page.selectedProfileType.id === _constants.SPECIALIST_PROFILE_TYPE && props.page.fetchedSpecialists || props.page.selectedProfileType && props.page.selectedProfileType.id === _constants.PRACTICE_PROFILE_TYPE && props.page.fetchedPractices || [],
                  readonly: !(props.page.selectedProfileType && (props.page.selectedProfileType.id === _constants.SPECIALIST_PROFILE_TYPE || props.page.selectedProfileType.id === _constants.PRACTICE_PROFILE_TYPE)),
                  selectedItem: props.page.selectedProfile,
                  onItemSelected: props.pageActions.onProfileSelected,
                  onTextChanged: function onTextChanged(filter) {
                    return props.pageActions.getDirectoryAutocomplete(filter, props.page.selectedProfileType && props.page.selectedProfileType.id);
                  },
                  placeholder: 'Type a name',
                  ItemRenderer: function ItemRenderer(rendererProps) {
                    var item = rendererProps.item,
                        nameTransform = rendererProps.nameTransform;

                    return _react2.default.createElement(
                      'div',
                      { className: '' + _style2.default.dropdownItem },
                      item.iconUri ? _react2.default.createElement('img', { src: item.iconUri }) : _react2.default.createElement('span', { className: _style2.default.imagePlaceholder }),
                      _react2.default.createElement(
                        'span',
                        null,
                        nameTransform(item)
                      )
                    );
                  } })
              ),
              _react2.default.createElement(
                'span',
                { className: _style2.default.selectDescription },
                'Layout:'
              ),
              _react2.default.createElement(
                'div',
                { className: _style2.default.dropdownContainer },
                _react2.default.createElement(_dropdown.Dropdown, {
                  className: _style2.default.profileDropdown,
                  items: [{
                    name: 'horizontal',
                    id: 'horizontal'
                  }, {
                    name: 'page',
                    id: 'page'
                  }],
                  selectedItem: props.page.selectedLayout,
                  onItemSelected: props.pageActions.onLayoutSelected,
                  readonly: true,
                  placeholder: 'Select a  layout',
                  ItemRenderer: function ItemRenderer(rendererProps) {
                    var item = rendererProps.item,
                        nameTransform = rendererProps.nameTransform;

                    return _react2.default.createElement(
                      'div',
                      { className: '' + _style2.default.dropdownItem },
                      item.iconUri ? _react2.default.createElement('img', { src: item.iconUri }) : _react2.default.createElement('span', { className: _style2.default.imagePlaceholder }),
                      _react2.default.createElement(
                        'span',
                        null,
                        nameTransform(item)
                      )
                    );
                  } })
              ),
              _react2.default.createElement(
                'div',
                null,
                showDefaultTabDropDown && _react2.default.createElement(
                  'span',
                  { className: _style2.default.selectDescription },
                  'Default tab:'
                ),
                showDefaultTabDropDown && _react2.default.createElement(
                  'div',
                  { className: _style2.default.dropdownContainer },
                  _react2.default.createElement(_dropdown.Dropdown, {
                    className: _style2.default.profileDropdown,
                    items: props.page.selectedProfileType.id === _constants.SPECIALIST_PROFILE_TYPE && _constants.SPECIALIST_TABS || props.page.selectedProfileType.id === _constants.PRACTICE_PROFILE_TYPE && _constants.PRACTICE_TABS || [],
                    readonly: true,
                    selectedItem: props.page.selectedDefaultTab,
                    onItemSelected: props.pageActions && props.pageActions.onDefaultTabSelected,
                    placeholder: 'Select a tab',
                    ItemRenderer: function ItemRenderer(rendererProps) {
                      var item = rendererProps.item,
                          nameTransform = rendererProps.nameTransform;

                      return _react2.default.createElement(
                        'div',
                        { className: _style2.default.dropdownItem + ' ' + _style2.default.slim },
                        _react2.default.createElement(
                          'span',
                          null,
                          nameTransform(item)
                        )
                      );
                    } })
                )
              ),
              _react2.default.createElement(
                'div',
                null,
                _ref4,
                _react2.default.createElement('input', {
                  className: _style2.default.checkbox,
                  type: 'checkbox',
                  name: 'disableBanner',
                  onClick: function onClick() {
                    props.pageActions.disableBanner(!props.page.disableBanner);
                  }
                }),
                _ref5,
                _react2.default.createElement('input', {
                  className: _style2.default.checkbox,
                  type: 'checkbox',
                  onClick: function onClick() {
                    props.pageActions.disableProfileImage(!props.page.disableProfileImage);
                  }
                }),
                _ref6,
                _react2.default.createElement('input', {
                  className: _style2.default.checkbox,
                  type: 'checkbox',
                  onClick: function onClick() {
                    props.pageActions.disableTabs(!props.page.disableTabs);
                  }
                })
              ),
              _react2.default.createElement(
                'div',
                { className: _style2.default["options-item"] },
                _react2.default.createElement(
                  'span',
                  { className: _style2.default.selectDescription },
                  'Minimal Rating Value'
                ),
                _react2.default.createElement(
                  'div',
                  { className: _style2.default.dropdownContainer },
                  _react2.default.createElement('input', {
                    type: "number",
                    value: props.page.customizations.minReviewRating,
                    min: "0",
                    max: "5",
                    onChange: function onChange(event) {
                      if (event && event.target) {
                        var number = (0, _utils.onNumberFieldChange)(event.target.value, 0, 5, props.page.customizations.minReviewRating);
                        event.target.value = number;
                        return _this2.setCustomizationProp("minReviewRating", number);
                      }
                    },
                    style: { width: '50px' }
                  })
                )
              )
            ),
            props.page.selectedProfileType && props.page.selectedProfile && _react2.default.createElement(
              'div',
              { className: _style2.default.codeSnippet },
              _ref7,
              _react2.default.createElement(
                'pre',
                null,
                _react2.default.createElement(
                  'code',
                  null,
                  '<iframe frameborder="0" src="',
                  'https://widgets.doctify.co.uk' + profileReviewsSearchQuery,
                  '" style="position:relative;display:initial;height:',
                  '' + (props.page.selectedLayout && props.page.selectedLayout.id === 'horizontal' ? '680px' : '951px'),
                  ';width:100%;border:none;"></iframe>'
                )
              )
            ),
            _react2.default.createElement(
              'div',
              { className: _style2.default.practiceReviewsIframe },
              _ref8,
              props.page.selectedProfileType && props.page.selectedProfile && _react2.default.createElement(_reactIframe2.default, {
                url: '' + baseUrl + profileReviewsSearchQuery,
                width: '100%',
                height: props.page.selectedLayout && props.page.selectedLayout.id === 'horizontal' ? '680px' : '951px',
                display: 'initial',
                position: 'relative'
              }) || _react2.default.createElement(
                'div',
                { className: [_style2.default.noPreview, _style2.default.practiceReviews].join(' ') },
                _ref9
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { className: _style2.default.exampleSection },
            _ref10,
            _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(
                'span',
                { className: _style2.default.selectDescription },
                'Profile Type:'
              ),
              _react2.default.createElement(
                'div',
                { className: _style2.default.dropdownContainer },
                _react2.default.createElement(_dropdown.Dropdown, {
                  className: _style2.default.profileDropdown,
                  items: [{
                    name: 'specialist',
                    id: _constants.SPECIALIST_PROFILE_TYPE
                  }],
                  readonly: true,
                  selectedItem: props.page.selectedProfileType,
                  onItemSelected: props.pageActions.onProfileTypeSelected,
                  placeholder: 'Select a profile type',
                  ItemRenderer: function ItemRenderer(rendererProps) {
                    var item = rendererProps.item,
                        nameTransform = rendererProps.nameTransform;

                    return _react2.default.createElement(
                      'div',
                      { className: '' + _style2.default.dropdownItem },
                      item.iconUri ? _react2.default.createElement('img', { src: item.iconUri }) : _react2.default.createElement('span', { className: _style2.default.imagePlaceholder }),
                      _react2.default.createElement(
                        'span',
                        null,
                        nameTransform(item)
                      )
                    );
                  } })
              ),
              props.page.selectedProfileType && (props.page.selectedProfileType.id === _constants.SPECIALIST_PROFILE_TYPE || props.page.selectedProfileType.id === _constants.PRACTICE_PROFILE_TYPE) && _react2.default.createElement(
                'span',
                { className: _style2.default.selectDescription },
                'Profile:'
              ),
              props.page.selectedProfileType && (props.page.selectedProfileType.id === _constants.SPECIALIST_PROFILE_TYPE || props.page.selectedProfileType.id === _constants.PRACTICE_PROFILE_TYPE) && _react2.default.createElement(
                'div',
                { className: _style2.default.dropdownContainer },
                _react2.default.createElement(_dropdown.Dropdown, {
                  className: _style2.default.profileDropdown,
                  items: props.page.selectedProfileType && props.page.selectedProfileType.id === _constants.SPECIALIST_PROFILE_TYPE && props.page.fetchedSpecialists || props.page.selectedProfileType && props.page.selectedProfileType.id === _constants.PRACTICE_PROFILE_TYPE && props.page.fetchedPractices || [],
                  readonly: !(props.page.selectedProfileType && (props.page.selectedProfileType.id === _constants.SPECIALIST_PROFILE_TYPE || props.page.selectedProfileType.id === _constants.PRACTICE_PROFILE_TYPE)),
                  selectedItem: props.page.selectedProfile,
                  onItemSelected: props.pageActions.onProfileSelected,
                  onTextChanged: function onTextChanged(filter) {
                    return props.pageActions.getDirectoryAutocomplete(filter, props.page.selectedProfileType && props.page.selectedProfileType.id);
                  },
                  placeholder: 'Type a name',
                  ItemRenderer: function ItemRenderer(rendererProps) {
                    var item = rendererProps.item,
                        nameTransform = rendererProps.nameTransform;

                    return _react2.default.createElement(
                      'div',
                      { className: '' + _style2.default.dropdownItem },
                      item.iconUri ? _react2.default.createElement('img', { src: item.iconUri }) : _react2.default.createElement('span', { className: _style2.default.imagePlaceholder }),
                      _react2.default.createElement(
                        'span',
                        null,
                        nameTransform(item)
                      )
                    );
                  } })
              )
            ),
            props.page.selectedProfileType && props.page.selectedProfile && _react2.default.createElement(
              'div',
              { className: _style2.default.codeSnippet },
              _ref11,
              _react2.default.createElement(
                'pre',
                null,
                _react2.default.createElement(
                  'code',
                  null,
                  '<iframe frameborder="0" src="',
                  'https://widgets.doctify.co.uk/booking-calendar?profileId=' + props.page.selectedProfile.uriId + '&profileType=' + props.page.selectedProfileType.id,
                  '" style="position:relative;display:initial;height:305px;width:100%;border:none;"></iframe>'
                )
              )
            ),
            _react2.default.createElement(
              'div',
              { className: _style2.default.practiceReviewsIframe },
              _ref12,
              props.page.selectedProfileType && props.page.selectedProfile && _react2.default.createElement(_reactIframe2.default, {
                url: baseUrl + '/booking-calendar?profileId=' + props.page.selectedProfile.uriId + '&profileType=' + props.page.selectedProfileType.id,
                width: '100%',
                height: '305px',
                display: 'initial',
                position: 'relative'
              }) || _react2.default.createElement(
                'div',
                { className: [_style2.default.noPreview, _style2.default.calendarExample].join(' ') },
                _ref13
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { className: _style2.default.exampleSection },
            _ref14,
            _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(
                'span',
                { className: _style2.default.selectDescription },
                'Profile Type:'
              ),
              _react2.default.createElement(
                'div',
                { className: _style2.default.dropdownContainer },
                _react2.default.createElement(_dropdown.Dropdown, {
                  className: _style2.default.profileDropdown,
                  items: _constants.PROFILE_TYPES,
                  readonly: true,
                  selectedItem: props.page.selectedProfileType,
                  onItemSelected: props.pageActions.onProfileTypeSelected,
                  placeholder: 'Select a profile type',
                  ItemRenderer: function ItemRenderer(rendererProps) {
                    var item = rendererProps.item,
                        nameTransform = rendererProps.nameTransform;

                    return _react2.default.createElement(
                      'div',
                      { className: '' + _style2.default.dropdownItem },
                      item.iconUri ? _react2.default.createElement('img', { src: item.iconUri }) : _react2.default.createElement('span', { className: _style2.default.imagePlaceholder }),
                      _react2.default.createElement(
                        'span',
                        null,
                        nameTransform(item)
                      )
                    );
                  } })
              ),
              props.page.selectedProfileType && (props.page.selectedProfileType.id === _constants.SPECIALIST_PROFILE_TYPE || props.page.selectedProfileType.id === _constants.PRACTICE_PROFILE_TYPE) && _react2.default.createElement(
                'span',
                { className: _style2.default.selectDescription },
                'Profile:'
              ),
              props.page.selectedProfileType && (props.page.selectedProfileType.id === _constants.SPECIALIST_PROFILE_TYPE || props.page.selectedProfileType.id === _constants.PRACTICE_PROFILE_TYPE) && _react2.default.createElement(
                'div',
                { className: _style2.default.dropdownContainer },
                _react2.default.createElement(_dropdown.Dropdown, {
                  className: _style2.default.profileDropdown,
                  items: props.page.selectedProfileType && props.page.selectedProfileType.id === _constants.SPECIALIST_PROFILE_TYPE && props.page.fetchedSpecialists || props.page.selectedProfileType && props.page.selectedProfileType.id === _constants.PRACTICE_PROFILE_TYPE && props.page.fetchedPractices || [],
                  readonly: !(props.page.selectedProfileType && (props.page.selectedProfileType.id === _constants.SPECIALIST_PROFILE_TYPE || props.page.selectedProfileType.id === _constants.PRACTICE_PROFILE_TYPE)),
                  selectedItem: props.page.selectedProfile,
                  onItemSelected: props.pageActions.onProfileSelected,
                  onTextChanged: function onTextChanged(filter) {
                    return props.pageActions.getDirectoryAutocomplete(filter, props.page.selectedProfileType && props.page.selectedProfileType.id);
                  },
                  placeholder: 'Type a name',
                  ItemRenderer: function ItemRenderer(rendererProps) {
                    var item = rendererProps.item,
                        nameTransform = rendererProps.nameTransform;

                    return _react2.default.createElement(
                      'div',
                      { className: '' + _style2.default.dropdownItem },
                      item.iconUri ? _react2.default.createElement('img', { src: item.iconUri }) : _react2.default.createElement('span', { className: _style2.default.imagePlaceholder }),
                      _react2.default.createElement(
                        'span',
                        null,
                        nameTransform(item)
                      )
                    );
                  } })
              ),
              _react2.default.createElement(
                'span',
                { className: _style2.default.selectDescription },
                'Theme:'
              ),
              _react2.default.createElement(
                'div',
                { className: _style2.default.dropdownContainer },
                _react2.default.createElement(_dropdown.Dropdown, {
                  className: _style2.default.profileDropdown,
                  items: [{
                    name: 'Light',
                    id: 'light'
                  }, {
                    name: 'Dark',
                    id: 'dark'
                  }],
                  readonly: true,
                  selectedItem: props.page.selectedTheme,
                  onItemSelected: props.pageActions.onThemeSelected,
                  placeholder: 'Select a theme',
                  ItemRenderer: function ItemRenderer(rendererProps) {
                    var item = rendererProps.item,
                        nameTransform = rendererProps.nameTransform;

                    return _react2.default.createElement(
                      'div',
                      { className: '' + _style2.default.dropdownItem },
                      item.iconUri ? _react2.default.createElement('img', { src: item.iconUri }) : _react2.default.createElement('span', { className: _style2.default.imagePlaceholder }),
                      _react2.default.createElement(
                        'span',
                        null,
                        nameTransform(item)
                      )
                    );
                  } })
              )
            ),
            props.page.selectedProfileType && props.page.selectedProfile && _react2.default.createElement(
              'div',
              { className: _style2.default.codeSnippet },
              _ref15,
              _react2.default.createElement(
                'pre',
                null,
                _react2.default.createElement(
                  'code',
                  null,
                  '<iframe frameborder="0" src="',
                  'https://widgets.doctify.co.uk/book-button?profileId=' + props.page.selectedProfile.uriId + '&profileType=' + props.page.selectedProfileType.id + '&theme=' + props.page.selectedTheme.id,
                  '" style="position:relative;display:block;height:48px;width:205px;border:none;border-radius:4px;overflow:hidden;"></iframe>'
                )
              )
            ),
            _react2.default.createElement(
              'div',
              { className: _style2.default.practiceReviewsIframe },
              _ref16,
              props.page.selectedProfileType && props.page.selectedProfile && _react2.default.createElement(_reactIframe2.default, {
                url: baseUrl + '/book-button?profileId=' + props.page.selectedProfile.uriId + '&profileType=' + props.page.selectedProfileType.id + '&theme=' + props.page.selectedTheme.id,
                width: '205px',
                height: '48px',
                display: 'block',
                position: 'relative',
                styles: { 'overflow': 'hidden' }
              }) || _react2.default.createElement(
                'div',
                { className: [_style2.default.noPreview, _style2.default.bookButtonExample].join(' ') },
                _ref17
              )
            )
          ),
          _react2.default.createElement(_reviewBadgeExample2.default, {
            title: 'Review Badge',
            baseUrl: baseUrl,
            uri: 'reviews-badge',
            hrefLink: props.page.hrefLink,
            selectedProfileType: props.page.selectedProfileType,
            selectedProfile: props.page.selectedProfile,
            selectedMultipleProfiles: props.page.selectedMultipleProfiles,
            fetchedSpecialists: props.page.fetchedSpecialists,
            fetchedPractices: props.page.fetchedPractices,
            onProfileTypeSelected: props.pageActions.onProfileTypeSelected,
            onProfileSelected: props.pageActions.onProfileSelected,
            onMultipleProfileSelected: props.pageActions.onMultipleProfileSelected,
            onMultipleProfileRemoved: props.pageActions.onMultipleProfileRemoved,
            getDirectoryAutocomplete: props.pageActions.getDirectoryAutocomplete,
            onHrefLinkChanged: props.pageActions.onHrefLinkChanged
          }),
          _react2.default.createElement(_wfListWidget2.default, (0, _extends3.default)({
            title: 'WF Doctify List (Responsive)',
            uri: 'wf-list-widget',
            layoutsList: _constants.WF_LIST_LAYOUTS
          }, props)),
          _react2.default.createElement(_wfMicroStarWidget2.default, (0, _extends3.default)({
            title: 'WF Micro Star (Responsive)',
            uri: 'wf-micro-star-widget',
            layoutsList: _constants.WF_MICRO_STAR_LAYOUTS
          }, props)),
          _react2.default.createElement(_wfCarouselWidget2.default, (0, _extends3.default)({
            title: 'WF Carousel (Responsive)',
            uri: 'wf-carousel-widget',
            layoutsList: _constants.WF_CAROUSEL_LAYOUTS
          }, props)),
          _react2.default.createElement(_wfGridWidget2.default, (0, _extends3.default)({
            title: 'WF Grid (Responsive)',
            uri: 'wf-grid-widget',
            layoutsList: _constants.WF_GRID_LAYOUTS
          }, props)),
          _react2.default.createElement(_wfHorizontalWidget2.default, (0, _extends3.default)({
            title: 'WF Horizontal (Responsive)',
            uri: 'wf-horizontal-widget',
            layoutsList: _constants.WF_HORIZONTAL_LAYOUTS
          }, props)),
          _react2.default.createElement(_wfPeerRecommendationWidget2.default, (0, _extends3.default)({
            title: 'WF Peer Recommendations (Responsive)',
            uri: 'wf-peer-recommendation-widget',
            layoutsList: _constants.WF_PEER_RECOMMENDATION_LAYOUTS
          }, props)),
          _react2.default.createElement(_wfGroupReviewsWidget2.default, (0, _extends3.default)({
            title: 'WF Group Reviews (Responsive)',
            uri: 'wf-group-reviews-widget',
            layoutsList: _constants.WF_GROUP_REVIEWS_LAYOUTS
          }, props))
        )
      )
    );
  };

  return WidgetExamples;
}(_react2.default.Component);

WidgetExamples.displayName = 'WidgetExamples';

var mapStateToProps = function mapStateToProps(state) {
  return {
    page: state.widgetExamples.page,
    global: state.global
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    pageActions: (0, _redux.bindActionCreators)(_pageActions.page, dispatch)
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(WidgetExamples);